export default "__VITE_ASSET__uPPbNOqh__"